import {
    DOMAIN,
    Header,
    ContentType,
    GetFormData,
    Method,
    http
} from './api-utils';

/**
 * app
 */
export const app = () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/app.json`
    }).then(res => res.data);
};

/**
 * app
 */
export const aiConfig = () => {
    return http({
        method: Method.GET,
        url: `${import.meta.env.BASE_URL}json/ai.json`
    }).then(res => res.data);
};
